module.exports = function() {
	return new Worker(__webpack_public_path__ + "ccdfd08e61ecd41ac218.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./src/vm/worker/index.ts
 ** module id = 886
 ** module chunks = 0
 **/